<template>
	<div>
		<Tou></Tou>
		<div class="w1500">
			<div class=" group-link felx mt-38 mb-41">
				<el-breadcrumb separator-class="el-icon-arrow-right">
					<el-breadcrumb-item class="tline" :to="{ path: '/' }">Home</el-breadcrumb-item>
					<el-breadcrumb-item :to="{ path: '/forum' }">Forum</el-breadcrumb-item>
					<el-breadcrumb-item>Post</el-breadcrumb-item>
				</el-breadcrumb>
			<!-- 	<el-link class="tit-16" :underline="false">Home</el-link>
				<i>></i>
				<el-link class="tit-16" :underline="false">Forum</el-link>
				<i>></i>
				<el-link class="tit-16" :underline="false">Post</el-link> -->
			</div>
			<!-- post表单 -->
			<div class="bj-0 br-10 PostFrom mb-30">
				<div class="pt-45 pr-56 pb-66 pl-57 fromBox">
					<div class="PostFrom-a1 mb-46.5 flex a-center">
						<div class="PostFrom-a1tiao"></div>
						<div class="z-282828 tit-30 B-400 ml-19 tle montserRegular">Post</div>
					</div>
					<div class="mt-43">
						<el-form ref="form" :model="postshu" label-width="0">
							<el-form-item label="" required class="Title mb-39">
								<div class="flex a-center">
									<div class="PostFrom-a2 z-E60012">＊</div>
									<div class="PostFrom-a3 pr-47 tit-20 ys-33 montserLight">{{gudingziduan.forum.Title}}:</div>
									<div class="PostFrom-a4s">
										<div class="PostFrom-a4">
											<el-input  @blur="checkLength" size="medium" class="PostFrominput" v-model="postshu.title"
												:placeholder="gudingziduan.forum.pleasetitle+'...'" placeholder-class="tit-16"
												placeholder-style="color:#A1A1A1;" maxlength="80" minlength="10" show-word-limit></el-input>
										</div>
										<div class="tit-8" style="color:red;position: absolute; line-height: 1;">Title must be 10-80 characters.</div>
									</div>
								</div>
							</el-form-item>
							<el-form-item label="" required class="Postto mb-43">
								<div class="flex a-center box">
									<div class="PostFrom-a2 z-E60012">＊</div>
									<div class="PostFrom-a3 pr-20 tit-20 ys-33 montserLight">{{gudingziduan.forum.postto}}:</div>
									<div class="PostFrom-a5 mr-31">
										<el-select class="post-group" v-model="postshu.exGroupId"
											:placeholder="gudingziduan.forum.pleaseselect">
											<el-option v-for="(l, i) in groupLie" :label="l.groupName"
												:value="l.id"></el-option>
										</el-select>
									</div>
									<div class="tips flex">
										<img class="mt-38 mr-4" style="width:16px;height:16px;"
											:src="require('@/assets/pc/group/zhuyi.png')">
										<div class="mt-41 tit-14 montserLight" style="color: #8D8D8D; line-height: 1;">
											{{gudingziduan.forum.selectgroup}}</div>
									</div>

								</div>
							</el-form-item>
							<el-form-item label="" required class="SetUp mb-80">
								<div class="flex box flex-wrap a-center">
									<!-- <div class="PostFrom-a2s z-E60012 mt-18">＊</div> -->
									<div class="PostFrom-a3s mr-21 tit-20 ys-33 montserLight">{{gudingziduan.forum.setreward}}:
									</div>
									<div class="PostFrom-btn tit-18 B-300 cur_pointer" @click="SetUp">{{gudingziduan.forum.setup}}</div>
									<div class="tit-16 B-300 ml-23 montserLight"><span class="z-777777">{{gudingziduan.forum.currentpoints}}：</span><span class="z-E70A16">{{ myshu.pointNum}}</span>
									</div>
								</div>
							</el-form-item>
							<el-form-item label="" required class="Content mb-47">
								<div class="bianji">
									<div class="flex mb-20">
										<div class="PostFrom-a2s z-E60012 mt-18">＊</div>
										<div class="PostFrom-a3s mt-18 mr-21 tit-20 ys-33 montserLight">{{gudingziduan.forum.content}}:</div>
									</div>
									<Bianjiqi v-model="postshu.content" ming="Content"></Bianjiqi>
									<div class="tit-8 mt-22" style="color:red;line-height: ;">Post must be 20-5000 characters.</div>
								</div>

							</el-form-item>
							<el-form-item label="" required class="Attachment rel">

								<el-upload class="upload-demo tit-15 pt-20" style="" ref="upload"
									action="https://community.goodwe.com/api/upload/file" :on-preview="handlePreview"
									:on-success="onSuccess" :on-remove="handleRemove" :file-list="fileList">
									<div class="flex a-center w100 flex-wrap box">
										<!-- <div class="PostFrom-a2s z-E60012" @click.stop>＊</div> -->
										<div class="PostFrom-a3s mr-21 tit-20 ys-33 montserLight" @click.stop>
											{{gudingziduan.forum.attachment}}:</div>
										<el-button slot="trigger" size="small" type="primary"
											class="PostFrom-btn1 tit-18 B-300 ys-33 B-400 mr-10 cur_pointer"
											style="border: none;background: #F5F5F5;montserLight">+ {{gudingziduan.forum.add}}</el-button>
										<div class="tit-14 B-300 z-5E666F montserLight" @click.stop>{{gudingziduan.forum.Supportedfile}}: ong,
											war, txt,
											docx, pdf, doc, xls, xlsx, ppt, pptx, ico, mp4, mp3 (Max: 5M)</div>
									</div>
								</el-upload>
							</el-form-item>
						</el-form>
					</div>
					<div class="w100 flex j-center">
						<div class="btn btnsave mr-29 cur_pointer" @click="baocun"><span
								class="iconfont tit-18 mr-13 icon-tongyong-pishiwenjianbianjiwenjianfankuixinxi1 ys-33"></span><span
								class="tit-16 ys-33 montserLight" >Save Drafts</span></div>
						<div class=" relres btn cur_pointer"  @click="release"><span class="iconfont icon-zhifeiji mr-18 tit-24"></span><span
								class="tit-16 montserLight ">Release</span></div>
					</div>
				</div>
			</div>
			<div class="bj-0 br-10 PostFrom mb-103" ref="caogaoxiang">
				<div class="pt-45 pr-56 pb-66 pl-57 fromBox">
					<div class="PostFrom-a1 mb-46.5 flex a-center">
						<div class="PostFrom-a1tiao"></div>
						<div class="z-282828 tit-30 B-400 ml-19 tle montserRegular"><strong>{{gudingziduan.forum.draftbox}}</strong></div>
					</div>
					<div class="flex j-between mt-44" style="flex-wrap: wrap;">
						<div class="Draft bj-F6F6F8 mb-24  cur_pointer flex" v-for="(l, index) in Draftlist">
							<div class="pt-37 pr-31 pb-28 pl-37 flex column flex1 j-between" style="width:90%;">
								<div>
									<div class="tit-20 ys-33 mb-20 montserLight">{{ l.title }}</div>
									<div class="post-draft-nr tit-16 montserLight" style="overflow: hidden;" v-html="l.content"></div>
								</div>
								<div class="flex j-between">
									<div class="post-draft-time mt-10 montserLight">{{ l.createTime }}</div>
									<div class="flex caocao">
										<div class="iconfont icon-bianji2 cur_pointer"  @click="bianji(l.id)"></div>
										<div class="iconfont icon-shanchu ml-11 mr-11 cur_pointer" @click="shanchu(l.id)"></div>
										<div class="iconfont icon-chakan cur_pointer" @click="yulang(l)"></div>
									</div>
								</div>
							</div>
						</div>
						<el-pagination class="flex j-center mt-10 w100 pb-10" @size-change="handleSizeChange"
							@current-change="handleCurrentChange" :current-page.sync="sos.pageNum" :page-size="sos.size"
							layout="prev, pager, next, jumper,slot" :total="zongshu">
							<span class="ml-10 cur_pointer" @click="goToPage">go</span>
						</el-pagination>
					</div>
				</div>
			</div>
		</div>
		<el-dialog class="setupjifen " title="Reward for points" :visible.sync="Setupbox">
			<el-form :model="setupshu">
				<el-form-item label="">
					<div class="tit-20 pb-22" style="color: #222222;">Points setting</div>
					<el-input v-model="setupshu.name" autocomplete="off"></el-input>
					<div style='color: #e60012;' class="tit-18 pt-18" v-if="myshu && myshu.pointNum">My point: {{ myshu.pointNum}}</div>
					<el-divider></el-divider>
				</el-form-item>
				<el-form-item label="">
					<div class="tit-20 pb-22" style="color: #222222;">
						Expiration Date
						<el-popover placement="top-start" title="" width="200" trigger="hover"
							content="If you don't choose thebest answer withinexpiration date,the system will selectthe most liked replyautomatically.">
							<span slot="reference" class="iconfont icon-kongxinwenhao"></span>
						</el-popover>
					</div>
					<ul class="flex-wrap j-between flex">
						<li @click="xuandate(i)" v-for="(d, i) in Dates" :class="Datesindex == i ? 'xuanDates' : ''"
							class="Datesitem tit-18 cur_pointer">
							{{ d.name }}
						</li>
						<!-- -->
					<!-- 	<li class="Datesitem Datesitem2 mt-30 tit-18" v-if="Datesindex == 3">
							<el-input type="number" v-model="Dates[Datesindex].zhi" autocomplete="off"></el-input>
						</li> -->
					</ul>
				</el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer flex j-center mt-40 pb-30 ">
				<el-button @click="Setupbox = false" class="tit-18 quxiao cur_pointer"
					style="font-weight: inherit;">Cancel</el-button>
				<el-button class="querensong tit-18 ys-0 cur_pointer" @click="xuanshangqueding">Submit</el-button>
			</div>
		</el-dialog>
		<!-- 预览 -->
	<!-- 	<div class="w100 h100" style="position: fixed;top:0;left: 0;background: rgba(0,0,0,0.5);z-index:9998;"></div>
		<div class="yulangbox">
		</div> -->
		<Foot></Foot>
	</div>

</template>

<script>
	let that;
import Tou from '../../../zuzuzu/touss.vue'
import Foot from '../../../zuzuzu/foot.vue'
import Bianjiqi from '../../../zujian/wangEditor.vue'
import Shangchuan from '../../../zujian/shangchuan/shangchuan.vue'
import { addPost, cuncaogao, editPost, deletePost } from '@/api/post.js';
import { groupList } from '@/api/group.js';
import {allUser} from '@/api/user.js';
export default {
	data() {
		return {
			menus: ['All Groups', 'Service Platform', 'Solar Discussion', 'Energy Storage', 'On Grid ', 'Ask for help ', 'Official Statement', 'Community Issue'],
			so: {},
			// 论坛话题
			zongshu: null,
			postshu: { title: '', attachments: [], content: '', exGroupId: '', rewardPrice: 0,postType: 0 },
			wenjianlei: [],
			showSetUp: false,
			Points: 0,
			fileList: [],
			Draftlist: [],
			Dates: [{ name: '1 day', zhi: '1' }, { name: '7 day', zhi: '7' }, { name: '15 day', zhi: '15' }, { name: '30 days', zhi: '30' }],
			Datesindex: 0,
			setupshu: {},
			Setupbox: false,
			groupLie: [],
			point: 0,
			sos: {
				pageNum: 1,
				size: 4
			},
			myshu:{},
			processedDraftlist:[],
			gudingziduan:{}
			
			
			
		}
	},
	components: { Tou, Foot, Bianjiqi, Shangchuan },
	mounted() {
		that = this;
		this.caogaoLie()
	},
	onLoad(e) {
		if(e.id) {
			
		}
	},
	watch: {
	    '$store.state.cunyuanyan': {
	      handler(newValue, oldValue) {
	        // console.log('语言已更新:', newValue);
	        this.gudingziduan=this.$store.state.cunyuanyan
			// console.log(this.gudingziduan,'video')
	      },
	      deep: true // 如果 cunyuanyan 是对象，需要设置 deep 为 true
	    }
	
	    // 'postshu.content': {
	    //   handler(newValue, oldValue) {
	    //     // 去除HTML标签，计算纯文本长度
	    //     const plainText = newValue.replace(/<[^>]*>/g, ''); 
	    //     const length = plainText.length;
	    //     console.log('纯文本内容的长度为:', length);
	    //     if (length < 20 || length > 5000) {
	    //       this.$message({
	    //         message: 'Post must be 20-5000 characters.',
	    //         type: 'warning'
	    //       });
	    //     }
	    //   },
	    //   deep: true,
	    //   immediate: true
	    // }
	  },
	created() {
		groupList().then(shu => {
			this.groupLie = shu.data
		})
		this.$store.commit('Gaiyuyan', this.$store.state.yuyan);
		this.gudingziduan=this.$store.state.cunyuanyan
		// 检查路由参数并加载数据
		if(this.$route.params.id) {
		    this.loadEditData(this.$route.params.id);
		  }
		// console.log(this.gudingziduan,'video2')
		allUser().then(s=>{
			this.myshu=s.data
		})
		
		
	},
	methods: {
		async loadEditData(id) {
		    const res = await editPost(id);
		    if(res.code === 200) {
		      this.postshu = {
		        title: res.data.theme || '',
		        attachments: res.data.attachments || [],
		        content: res.data.content || '',
		        exGroupId: res.data.groupId || '',
		        rewardPrice: res.data.rewardPrice || 0,
		        postType: res.data.postType || 0,
		        rewardTime: res.data.rewardTime || ''
		      };
		    }
		  },
		caogaoLie() {
			let fenye = {}
			fenye.pageNum  = this.sos.pageNum-1
			fenye.size  = this.sos.size
			cuncaogao(fenye).then(shu => {
				this.Draftlist = shu.data.content
				for (let i in this.Draftlist) {
					this.Draftlist[i].content=this.Draftlist[i].content.replace(/<img.*?src=["'](.*?)["'].*?>/gi, '');
				}
				this.zongshu = Number(shu.data.totalElements)
				// console.log(this.Draftlist)
		})
		},
		yulang(e){
			// window.open('https://www.semsportal.com/preview_details")
			this.$cun('yulangshu',e)
			setTimeout(() => {
				this.$router.push({ name: 'preview_details'})

				// this.$dakai('/preview_details')
			}, 1000);
		},
		removeImageTags(html) {
		    return html.replace(/<img.*?src=["'](.*?)["'].*?>/gi, '');
		},
		Change(e) {
			// console.log(e,'图数据')
			if (e && e.length > 0) {
				for (let i in e) {
					this.editor.cmd.do("insertHTML", '<img src="' + e[i] +
						'" style="display: flex;max-width:100%;" />');
					// this.editor.cmd.do('insertImage', e[i])
				}
			}
		},
		handleCurrentChange(e) {
			this.sos.pageNum = e
			this.caogaoLie()
			
			// console.log(e,'handleCurrentChange')
		},
		handleSizeChange(e) {
			// console.log(e,'handleSizeChange')
		},
		shanchu(id) {
			const loading = this.$loading({
				target: this.$refs.caogaoxiang,
			  lock: true,
			  text: 'Deleting',
			  spinner: 'el-icon-loading',
			  background: 'rgba(0, 0, 0, 0.2)'
			});
			setTimeout(() => {
			  loading.close();
			}, 2000);
			deletePost(id).then(res => {
				if(res.code == 200) {
					this.$xiaoxi(res.message)
					location.reload();
				}
			})
		},
		async bianji(id) {
		    const loading = this.$loading({
		      lock: true,
		      text: 'Loading',
		      spinner: 'el-icon-loading', 
		      background: 'rgba(0, 0, 0, 0.2)'
		    });
		
		    try {
		      const res = await editPost(id);
		      if(res.code == 200) {
		        this.postshu = {
		          title: res.data.theme || '',
		          attachments: res.data.attachments || [],
		          content: res.data.content || '',
		          exGroupId: res.data.groupId || '',
		          rewardPrice: res.data.rewardPrice || 0,
		          postType: res.data.postType || 0,
		          rewardTime: res.data.rewardTime || ''
		        };
				await this.$nextTick();
				window.scrollTo({
				  top: 0,
				  behavior: 'smooth'
				});
		        // 添加滚动到顶部逻辑
				
		        this.$router.push(`/forum/post/${id}`);


		
		      }
		    } catch (error) {
		      console.error('error:', error);
		    } finally {
		      loading.close();
		    }
		  },
		// bianji(id) {
		// 	this.$router.push({ query: { id: id } });
		// 	const loading = this.$loading({
		// 	  lock: true,
		// 	  text: 'Loading',
		// 	  spinner: 'el-icon-loading',
		// 	  background: 'rgba(0, 0, 0, 0.2)'
		// 	});
		// 	setTimeout(() => {
		// 	  loading.close();
		// 	}, 2000);
		// 	editPost(id).then(res => {
		// 		if(res.code == 200) {
		// 			this.postshu.title = res.data.theme
		// 			this.postshu.attachments = res.data.attachments
		// 			this.postshu.content = res.data.content
		// 			this.postshu.exGroupId = res.data.groupId
		// 			this.postshu.rewardPrice = res.data.rewardPrice
		// 			this.postshu.postType = res.data.postType
		// 			this.postshu.rewardPrice=res.data.rewardPrice;
		// 			this.postshu.rewardTime=res.data.rewardTime;
					
		// 		}
				
		// 	})
		// },
		goToPage() {
			this.handleCurrentChange(this.sos.ye)
		},
		handleRemove(file, fileList) {
			const indexToRemove = this.wenjianlei.findIndex(item => item.uid === file.uid);
			if (indexToRemove !== -1) {
			  this.wenjianlei.splice(indexToRemove, 1);
			}
		},
		checkLength(){
			if(this.postshu.title.length < 10){
				this.$message({
				  showClose: true,
				  iconClass:'el-icon-warning',
				  customClass:'my-error-message',
				  message:'Title must be 10-80 characters.',
				  type: 'error',
				  offset:'350',
				  duration:0
				})
			}
		},
		handlePreview(file) {
			// console.log(file, 'filefilefilefilefilefilefilefilefile');
		},
		xuanshangqueding(){
			this.Setupbox = false;
			this.postshu.rewardPrice=this.setupshu.name;
			this.postshu.rewardTime=this.Dates[this.Datesindex].zhi;
		},
		release() {
			if(this.postshu.title.length < 10 || this.postshu.title.length >80){
				this.$message({
				  showClose: true,
				  iconClass:'el-icon-warning',
				  customClass:'my-error-message',
				  message:'Title must be 10-80 characters.',
				  type: 'error',
				  offset:'350',
				  duration:0
				})
			}else{
				 const plainText = this.postshu.content.replace(/<[^>]*>/g, '');
				 // console.log(plainText.length)
				  if (plainText.length < 20 || plainText.length > 5000) {
					  // console.log(plainText.length)
						this.$message({
						  showClose: true,
						  iconClass:'el-icon-warning',
						  customClass:'my-error-message',
						  message:'Post must be 20-5000 characters.',
						  type: 'error',
						  offset:'350',
						  duration:0
						})
				}else if(plainText.length> 20 && plainText.length < 5000){
					if(!this.postshu.exGroupId){
						this.$message({
						  showClose: true,
						  iconClass:'el-icon-warning',
						  customClass:'my-error-message',
						  message:'click to select group',
						  type: 'error',
						  offset:'350',
						  duration:0
						})
					}else{
						const filePaths = this.wenjianlei.map(file => file.data);
						const result = filePaths.join(',');
						// this.postshu.rewardPrice=this.setupshu.name;
						// this.postshu.rewardTime=this.setupshu.date;
						this.postshu.attachments=result;
						this.postshu.issueType = 1 // 发布帖子
						this.tiezi(this.postshu)
					}
				}
			}
		},
		SetUp() {
			this.Setupbox = true
		},
		onSuccess(e,file, fileList) {
			if (e.code == 200) {
				that.wenjianlei.push({
				  data: e.data,
				  uid: file.uid // el-upload 会为每个文件生成一个唯一的 uid
				}) 
			}
		},
		baocun() {
			if(this.postshu.title.length < 10){
				this.$message({
				  showClose: true,
				  iconClass:'el-icon-warning',
				  customClass:'my-error-message',
				  message:'Title must be 10-80 characters.',
				  type: 'error',
				  offset:'350',
				  duration:0
				})
			}else{
				this.postshu.attachments='';
				this.postshu.issueType = 0 // 存草稿
				if(this.$route.params.id) {
					this.postshu.id = this.$route.params.id
				}
				
				if(!this.postshu.rewardPrice){
					this.postshu.rewardPrice=0
				}
				if(!this.postshu.postType){
					this.postshu.postType=0
				}
				this.tiezi(this.postshu)
				this.$router.push('/forum/post');
			}
		},
		tiezi(e) {
			// console.log(e)
			addPost(e).then(shu => {
				if(e.issueType == 1) {// 发布帖子
					if(shu.code>200){
						// console.log(111)
						this.$message({
						  showClose: true,
						  iconClass:'el-icon-warning',
						  customClass:'my-error-message',
						  message:shu.message,
						  type: 'error',
						  offset:'350',
						  duration:0
						})
					}else{
						this.$message({
						  showClose: true,
						  message:shu.message,
						  type: 'success',
						  offset:'350',
						  duration:2000
						})
						setTimeout(()=> {
							this.$houtui()
						},2000)
					}
				}else { // 存草稿
					this.postshu = {}
					this.wenjianlei = []
					this.$message({
					  showClose: true,
					  message:'Save successfully',
					  type: 'success',
					  offset:'350',
					  duration:2000
					})
					this.caogaoLie()
					setTimeout(()=> {
						// location.reload();
					const draftBox = this.$refs.caogaoxiang;
					if (draftBox) {
						draftBox.scrollIntoView({ behavior:'smooth' });
					}
					},1000)
				}
				
			})
		},
		xuandate(e) {
			this.Datesindex = e
			this.setupshu.date = this.Dates[e].zhi
			// console.log(this.setupshu.date)
		}
	}
}
</script>

<style lang="scss">
body {
	background-color: #f6f7f8 !important;
}

.over-hidden {
	overflow: hidden;
}
.yulangbox{
	position: fixed;
	width:8.9rem;
	height:6.4rem;
	z-index: 9999;
	background: #fff;
	top:50%;
	left:50%;
	margin-left: -4.45rem;
	margin-top:-4.2rem;
	border-radius: .15rem;
}
.f-wrap {
	flex-wrap: wrap;
}

.group-link {
	color: #939393;
}

.zic-88 {
	color: #888888;
}

.z-FF071C {
	color: #FF071C;
}

.z-E60012 {
	color: #E60012;
}

.z-E70A16 {
	color: #E70A16
}

.z-777777 {
	color: #777777
}

.z-5E666F {
	color: #5E666F;
}

.bj-F6F6F8 {
	background: #F6F6F8;
}

.z-282828 {
	color: #282828;
}

.Datesitem {
	display: inline-block;
	width: calc(100% / 4 - 2%);
	text-align: center;
	border-radius: .1rem;
	border: 1px solid #b0b0b0;
	box-sizing: border-box;
	padding: .11rem .05rem;
}

.Datesitem2 {
	height: 50px;

	.el-input__inner {
		height: 50px;
		border: none;
		background: none;
	}
}

.setupjifen {

	.el-dialog {
		width: 60%;
	}

	.el-dialog__headerbtn {
		padding: 0;
	}

	.el-icon-close {
		font-size: .3rem;
		padding: 0;
	}

	.el-dialog__headerbtn:focus .el-dialog__close,
	.el-dialog__headerbtn:hover .el-dialog__close {
		color: #eb3341;
	}

	button {
		background: none;
		border-radius: 25px;
		padding: .1rem .35rem;
	}

	.quxiao {
		border: 1px solid #eb3341;
		color: #eb3341;
	}

	.quxiao:hover,
	.quxiao:active,
	.quxiao:focus {
		background: none;
	}

	.querensong {
		background-image: linear-gradient(4deg, rgb(255, 117, 88) 0%, rgb(230, 0, 18) 100%);
		color: #fff;
		border: 0;
	}

	ul li {
		color: #222222;
	}

	.el-dialog__title {
		font-size: 26px;
	}
}

.Datesitem {
	margin-right: 2%;
}

.xuanDates {
	background: red !important;
	color: #fff !important;
	border-color: red;
}

// .Datesitem:not(:last-child){
// 	margin-right: ;
// }
.bianji {
	.w-e-text-container {
		height: 2.64rem !important;
	}
}

.addbg {
	background-color: #F5F5F5;
}

// ==============
.PostFrom-a1tiao {
	width: 8px;
	height: 28px;
	background: #e60012;
	border-radius: 4px;
}

.PostFrom {
	.tle {
		font-family: "montserRegular";
	}

	.el-input__inner {
		border: none !important;
		border-radius: 10px;
	}

	.btn {
		padding: .1rem .3rem;
		color: #fff;
		border-radius: 50px;
		display: flex;
		align-items: center;
		background: none;
		transition: .5s;


	}

	.btnsave {
		border: 1px solid #e70a16;
		box-sizing: border-box;
		background-color: #fff;

		&:hover {
			background: #e60012;
			color: #fff;

			span {
				color: #fff;
			}
		}
	}

	.relres {
		padding: .1rem .45rem;
		display: flex;
		align-items: center;
		background: linear-gradient(-26deg, #e70a16 0%, #ff785c 100%);
	}
	.PostFrom-a4s{
		width: 92%;
	}	
	.PostFrom-a4 {
		height: .7rem;
		min-height: 45px;
		width:100%;
		border: 1px solid #e9e9e9;
		border-radius: 10px;
		overflow: hidden;

		.el-input {
			height: 100%;

			.el-input__inner {
				height: 100%;
			}
		}
	}

	.PostFrom-a5 {
		height: .66rem;
		min-height: 40px;
		width: 24%;
		border: 1px solid #e9e9e9;
		border-radius: 10px;
		overflow: hidden;

		.post-group {
			width: 100%;
			height: 100%;
		}

		.el-input {
			height: 100%;
			padding: 0 .19rem 0 .29rem;

			.el-input__inner {
				padding: 0;
				height: 100%;
			}
		}
	}

	.PostFrom-btn {
		padding: .1rem .5rem;
		color: #fff;
		background: linear-gradient(-50deg, #e70a16 0%, #ff785c 100%);
		border-radius: 100px;
		display: inline-block;
	}

	.PostFrom-btn1 {
		padding: .1rem .5rem;
		color: #333;
		background: #f5f5f5;
		border-radius: 23px;
		display: inline-block
	}

	.PostFrom-a2 {
		// color:#;
		height: 70px;
		line-height: 70px;
	}

	.PostFrom-a3 {
		height: 70px;
		line-height: 70px;
	}

	.el-upload-list {
		display: flex;
		flex-wrap: wrap;
		margin-top: .43rem;

		// width: 100%;
		.el-upload-list__item {
			line-height: normal;
			// padding: 0;
			padding: .14rem .17rem;
			margin-top: 0;
			color: #9A9A9A;
			font-weight: 300;
		}

		.el-upload-list__item:not(:last-child) {
			margin-right: .17rem;
		}

		li {
			border: 1px dashed #dfdfdf;
			border-radius: 23px;
			width: auto;
		}
	}

	.Draft {
		width: 48%;
		min-height: 2.6rem;
		border-radius: 10px;
	}

	.Draft:nth-child(2n-1) {
		// margin-right: ;
	}

	.post-draft-nr {
		display: -webkit-box;
		-webkit-box-orient: vertical;
		-webkit-line-clamp: 2;
		overflow: hidden;
		font-weight: normal;
		color: #888;
	}

	.post-draft-time {
		color: #888;
	}

	.caocao {
		.iconfont {
			color: #9B9B9B;
			width: 39px;
			height: 39px;
			border-radius: 50%;
			line-height: 39px;
			background: #E6E6E6;
			text-align: center;
		}

		.iconfont:hover {
			background: red;
			color: #fff;
		}
	}

}

.el-dialog {
	border-radius: 10px !important;
}



// ==========================================================================================================================================================================
// 响应式
@media screen and (max-width: 767px) {
	.PostFrom .fromBox {
		padding: .3rem;
	}

	.PostFrom .Title {
		margin-bottom: 0;
	}

	.Postto .box {
		flex-wrap: wrap;

		.tips {
			width: 100%;
			align-items: flex-end;

			img {
				margin: 0;
			}

			div {
				margin: 0;
			}
		}
	}

	.PostFrom .PostFrom-a5 {
		width: 70%;
		margin: 0;
	}

	.setupjifen .el-dialog {width: 95%;}
	.setupjifen .Datesitem {width: 48%;margin-top: .2rem;}
	.setupjifen .el-dialog__body {padding-bottom: 0;}

	.PostFrom .Draft {width: 100%;}
}
</style>